// extracted by mini-css-extract-plugin
export var buttons = "StockTransferVenueSelectModal-module--buttons--W6-u1";
export var container = "StockTransferVenueSelectModal-module--container--haMz9";
export var form = "StockTransferVenueSelectModal-module--form--8+LWc";
export var thumbnail = "StockTransferVenueSelectModal-module--thumbnail--3DBTW";
export var thumbnailBadge = "StockTransferVenueSelectModal-module--thumbnailBadge--rH27q";
export var thumbnailWrapper = "StockTransferVenueSelectModal-module--thumbnailWrapper--k7JU8";
export var welcomeContent = "StockTransferVenueSelectModal-module--welcomeContent--NCHOj";